import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createModalProps, createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";
import { ModalCreateCompany } from "../../ModalCreateCompany";

/**
 * @param onSelectResource opcional — recebe o CADASTRO inteiro da
 *        transportadora escolhida (com CNPJ, IE e endereço). Quem precisa
 *        desses dados (a emissão de nota) evita uma segunda requisição, já
 *        que a listagem os traz.
 * @param create como nos demais selects. Aqui ele também inclui a
 *        transportadora nova na lista, que é carregada uma vez só.
 */
export const SelectShippingCompany = ({selectedShippingCompany, setSelectedShippingCompany, onSelectResource, create}) => {
    const [loading, setLoading] = useState(true);
    const [showCreate, setShowCreate] = useState(false);

    const [shippingCompany, setShippingCompany] = useState([]);
    const [resources, setResources] = useState([]);

    useEffect(() => {
        getShippingCompany();
    }, []);

    // Guarda o cadastro inteiro (aceita resposta paginada ou array direto) e
    // deriva dele a lista do select — buscar duas vezes o mesmo dado seria
    // desperdício.
    const rawList = (resources, kind) => {
        const list = resources?.data ?? resources ?? [];
        return (Array.isArray(list) ? list : []).map(item => ({ ...item, kind }));
    };

    const handleChange = id => {
        setSelectedShippingCompany(id);

        if (onSelectResource) {
            onSelectResource(resources.find(resource => resource.id === id) ?? null);
        }
    };

    const addCreated = company => {
        const resource = { ...company, kind: 'company' };

        setResources(current => [...current, resource]);
        setShippingCompany(current => [...current, { id: company.id, code: company.code, trade_name: company.trade_name }]);
        setShowCreate(false);
        setSelectedShippingCompany(company.id);

        if (onSelectResource) onSelectResource(resource);
    };

    const getShippingCompany = () => {
        setLoading(true);

        // Transportadoras podem ser empresas (company type shipping)
        // OU pessoas/customers do tipo transportadora (customer type shipping).
        const companiesReq = api.get(`/company?filters[0][type][contain]=shipping&per_page=100`)
            .then(res => rawList(res.data.resources, 'company'))
            .catch(() => []);

        const customersReq = api.get(`/customer?filters[0][type][contain]=shipping&per_page=100`)
            .then(res => rawList(res.data.resources, 'customer'))
            .catch(() => []);

        Promise.all([companiesReq, customersReq]).then(([companies, customers]) => {
            const all = [...companies, ...customers];

            setResources(all);
            setShippingCompany(all.map(item => ({
                id: item.id,
                code: item.code,
                trade_name: item.trade_name ?? item.name
            })));
        }).catch(error => {
            renderError(error);
        }).then(() => {
            setLoading(false);
        });
    }

    return (
        <>
            {create &&
                <ModalCreateCompany
                    type={['shipping']}
                    {...createModalProps(create)}
                    show={showCreate}
                    close={() => setShowCreate(false)}
                    companyStored={addCreated}
                    showSuccess={false}
                />
            }
            <InputSelect
                loading={loading}
                label={`Transportadora`}
                options={createOptions(shippingCompany, ['code', 'trade_name'], 'id', true, null, 'Selecione...')} 
                value={selectedShippingCompany} 
                change={handleChange}
                onCreate={create ? () => setShowCreate(true) : undefined}
            />
        </>
    );
}

export default SelectShippingCompany;